export function validateOnSave(category) {
  if (!category) {
    return Promise.reject('Missing Category entity.')
  }

  const name = (category.name || '').trim()

  if (name.length === 0) {
    return Promise.reject('Category name can\'t be empty.')
  }

  return Promise.resolve(true)
}
